export default __webpack_public_path__ + "static/media/btn_str_match_ban.917551e5.svg";